import { useSelector } from "@tanstack/react-store"
import { onboardingStore } from "./onboarding-store"

export function useOnboardingFormValues() {
	return useSelector(onboardingStore, (s) => s.formValues)
}
